<template>
    <CustomAutocomplete :completeFunction="searchOwner" :emptyValue="false" :dropdown="dropdown" v-model="internalValue"
                        :name="name" :label="label" :width="width" :customErrorMessage="customErrorMessage"
                        :itemFromQuery="false" :disabled="disabled" :required="required" :field="searchParam"
                        :showErrors="showErrors" completeOnFocus itemValue="fullName"
                        :noPlaceholder="noPlaceholder"/>
</template>

<script>
    import {searchOwnerForHorseForm} from "@/swagger/vue-api-client";
    import CustomAutocomplete from "@/components/form/inner/CustomAutocomplete.vue";

    export default {
        name: "CustomAutocompleteOwner",
        components: {CustomAutocomplete},
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            modelValue: null,
            searchParam: {
                type: String,
                default: "fullName",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            customErrorMessage: {
                type: String,
                default: "",
            },
            showErrors: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            dropdown: {
                type: Boolean,
                default: false,
            },
            width: {
                type: String,
                default: null,
            },
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: "",
            },
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() { return this.modelValue; },
                set(value) { this.$emit("update:modelValue", value); },
            },
        },

        data() {
            return {
                items: [],
                selectedValue: null,
                searchOwner: async (obj) => {
                    const { query } = obj;
                    return searchOwnerForHorseForm({phrase: query});
                },
            };
        },

    };
</script>

<style scoped>

</style>
